import { useStore } from '@/store'
import { filterLocaisCentro } from '@acme/common'

type Dependencies =
    NonNullable<Parameters<typeof filterLocaisCentro>[2]> extends (
        item: unknown,
    ) => infer TDependencies
        ? TDependencies
        : never

/**
 * Filtra os dados por centros de custo e locais,
 * usando os centros de custo armazenados no useStore.
 */
export function useFilterLocaisCentroStore<T = any>(
    accessor?: (item: T) => Dependencies,
) {
    const centroCustoIdsStore = useStore(state => state.costCenterId)
    const locaisStore = useStore(state => state.locaisIds)

    return filterLocaisCentro<T>(locaisStore, [centroCustoIdsStore], accessor)
}
